import {
  type AnimationOptionFlip,
  TileRotatePattern,
} from "@package/ui-gql/index-data-access";
import { type CSSProperties, useMemo } from "react";
import { type AnimationComponentProps } from "./animated-card-interface";

export function AnimationCardFlip({
  animation,
  nodeCurr,
  nodePrev,
  reversed,
}: AnimationComponentProps<AnimationOptionFlip>) {
  const styleCardInner = useMemo<CSSProperties>(() => {
    let styles: CSSProperties = {
      transition: `transform ${animation.duration}s`,
      transformStyle: "preserve-3d",
    };

    if (reversed) {
      styles = {
        ...styles,
        transform:
          animation.direction === TileRotatePattern.Horizontal
            ? "rotateY(180deg)"
            : "rotateX(180deg)",
      };
    }

    return styles;
  }, [animation.direction, animation.duration, reversed]);

  const styleCardFaceFront = useMemo<CSSProperties>(
    () => ({
      backfaceVisibility: "hidden",
    }),
    [],
  );

  const styleCardFaceBack = useMemo<CSSProperties>(
    () => ({
      backfaceVisibility: "hidden",
      transform:
        animation.direction === TileRotatePattern.Horizontal
          ? "rotateY(180deg)"
          : "rotateX(180deg)",
    }),
    [animation.direction],
  );

  return (
    <div className="relative w-full h-full">
      <div className="relative w-full h-full" style={styleCardInner}>
        <div
          className="absolute w-full h-full backface-hidden"
          style={styleCardFaceFront}
        >
          {nodeCurr}
        </div>
        <div
          className="absolute w-full h-full backface-hidden"
          style={styleCardFaceBack}
        >
          {nodePrev}
        </div>
      </div>
    </div>
  );
}
